import {TSMap} from "typescript-map";
import {Quote} from "platform/protocol/trading/Quote";

export class QuotesState {

    private static _instance: QuotesState;
    private _quotes: TSMap<number, Quote> = new TSMap<number, Quote>();

    private constructor() {
    }

    public static instance(): QuotesState {
        return this._instance || (this._instance = new this());
    }

    public get quotes(): TSMap<number, Quote> {
        return this._quotes;
    }

    public set quotes(value: TSMap<number, Quote>) {
        this._quotes = value;
    }
}
